import React from 'react';

const LegalDocumentModal = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent px-4">
      <div
        className="flex w-full max-w-[92vw] flex-col overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg sm:max-w-md md:max-w-lg"
        style={{ maxHeight: '75vh' }}
      >
        <div className="flex items-center justify-between border-b p-4">
          <h3 className="text-base font-semibold text-gray-900 md:text-lg">{title}</h3>
          <button
            type="button"
            className="rounded-md px-3 py-1 text-sm text-gray-700 hover:bg-gray-100"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </div>
    </div>
  );
};

export default LegalDocumentModal;
